import { render, staticRenderFns } from "./CurrentNegotiationColumnTemplate.vue?vue&type=template&id=448560ca"
import script from "./CurrentNegotiationColumnTemplate.vue?vue&type=script&lang=js"
export * from "./CurrentNegotiationColumnTemplate.vue?vue&type=script&lang=js"
import style0 from "./CurrentNegotiationColumnTemplate.vue?vue&type=style&index=0&id=448560ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports